import request from '../../utils/request'
import {API} from '../../utils/constant'

export default {
  getList (params) {
    return request.get(API.MANAGER, params)
  },
  getDetail (params) {
    return request.get(API.MANAGER_EMPLOYEE + params.id)
  },
  add (params) {
    return request.post(API.ADD_EMPLOYEE, params)
  },
  edit (params) {
    return request.post(API.MANAGER_EMPLOYEE + params.id, params.formData)
  },
  delete (params) {
    return request.delete(API.MANAGER_EMPLOYEE + params.id)
  },
  getHisitoryLogs (params) {
    return request.get(API.MANAGER_HISTORY, params)
  },
  archiveEmployee (params) {
    return request.put(API.MANAGER_ARCHIVE_EMPLOYEE + params)
  },
  unArchiveEmployee (params) {
    return request.post(API.MANAGER_ARCHIVE_EMPLOYEE + params)
  }
}



// WEBPACK FOOTER //
// ./src/api/manager/employee.js